var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClroboostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3713_3065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.00018C5 1.89561 5.89543 1.00018 7 1.00018H19C20.1046 1.00018 21 1.89561 21 3.00018V15.0002C21 16.1048 20.1046 17.0002 19 17.0002H7C5.89543 17.0002 5 16.1048 5 15.0002V3.00018Z",
    fill: "#FCFCFC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.00018C5.5 2.17176 6.17157 1.50018 7 1.50018H19C19.8284 1.50018 20.5 2.17176 20.5 3.00018V15.0002C20.5 15.8286 19.8284 16.5002 19 16.5002H7C6.17157 16.5002 5.5 15.8286 5.5 15.0002V3.00018Z",
    stroke: "#E0DDEE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3264 11.6207C10.7437 11.0539 10.384 10.2938 10.3152 9.48066H12.9678C13.0172 9.57079 13.0896 9.64525 13.1774 9.69791C13.2651 9.75056 13.3647 9.7795 13.4669 9.78025C13.6225 9.77672 13.7703 9.71118 13.8781 9.59804C13.9859 9.4849 14.0453 9.33262 14.0424 9.17582C14.0443 9.01972 13.985 8.86932 13.8772 8.7571C13.7695 8.64488 13.6218 8.57994 13.4669 8.57664C13.3646 8.57738 13.2643 8.60616 13.1765 8.65899C13.0887 8.71182 13.017 8.78675 12.9678 8.87711H10.3152C10.3838 8.06317 10.7434 7.30213 11.3264 6.73445C11.9006 6.17696 12.6651 5.86385 13.4625 5.85934H17.1714V5.50018L18 6.17382L17.1714 6.82818V6.46902H15.2813C15.7014 6.78289 16.0421 7.19173 16.276 7.66299C16.5098 8.13425 16.6309 8.65507 16.6281 9.18195C16.6441 10.0443 16.3194 10.8777 15.7265 11.4998C15.1336 12.1219 14.3201 12.4813 13.4643 12.5002C12.6654 12.496 11.8997 12.1812 11.3264 11.6207ZM8 9.48066V8.87711H10.3152C10.3063 8.97668 10.3005 9.07894 10.3005 9.17582C10.3005 9.2727 10.3055 9.38203 10.3144 9.47891L8 9.48066Z",
    fill: "#002D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3713_3065",
    x: 0,
    y: 0.000183105,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3713_3065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3713_3065",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClroboostIcon);
export default __webpack_public_path__ + "static/media/clroboostIcon.468dac4c21450e139dea82bcb5b7ceb9.svg";
export { ForwardRef as ReactComponent };